<template>
    <div id="bene-province-street-container">
      <f7-list form class="form-group" v-if="showFormSet.provinceDetails">
          <f7-list-input
              input-id     ="street"
              name         ="street"
              type         ="text"

              :label       ="streetLabel"
              :placeholder ="streetLabel"
              :value       ="street"
              @change      ="setStreet($event.target.value); validateInput($event.target); setInput($event.target)"

              v-show       ="!isDropdown"
              autocomplete ="off"
              maxlength    ="100"
              outline
              floating-label
              clear-button
          ></f7-list-input>

          <f7-list-input
                input-id     ="streetDropdown"
                id           ="streetInput"
                name         ="streetDropdown"
                class        ="clickable-row use-chevron"
                @change      ="changeStreet($event.target.value)"
                v-if         ="true"
                :label       ="streetLabel"
                :placeholder ="streetLabel"
                :value       ="street"
                
                v-show       ="isDropdown"
                outline
                floating-label
            >
                <f7-link popover-open=".popover-dropdown-street" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover id="dropdownStreet" class="popover-dropdown-street dropdown-default dropdown beneficiary" :backdrop="true">
                <f7-list>
                    <f7-list-item popover-close link="#"
                    v-for="item in streetList"
                    :key="item.key"
                    selected=""
                    @click="changeStreet(item.key); validateInput($event.target);setInput('streetDropdown');">
                    {{item.value}}
                    </f7-list-item>
                </f7-list>
            </f7-popover>
      </f7-list>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {

    },
    mounted (){
      // console.log("provinceList: ", this.provinceList)
      this.init()
    },
    data: function() {
        return {
            //isDropdown : false
        }
    },
    computed: {
      ...mapGetters('beneficiary', [
          'showFormSet',
          'showFormInput',
          'street',
          'streetLabel',
          'postcode',
          'showPreloaderState',
          'streetList',
          'isDropdown'
      ])
    },
    methods: {
      ...mapActions('beneficiary', [
          'setStreet',
          'setPostcode',
          'setShowPreloaderState',
      ]),

      async init(){
          const self    = this;
          const popover = ".beneficiary.popover-dropdown-street";
          const popoverInner = ".beneficiary.popover-dropdown-street .popover-inner";
          const popoverId = "dropdownStreet";
          const inputId = "streetDropdown";
          const inputListId = "#streetInput";
          await self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)
      },

      changeStreet(id){
          this.$emit("changeStreet", id);
      },

      validateInput(inputEl){
        this.showPreloader();
        this.$emit("validateInput", inputEl);
        this.hidePreloader();
      },

      setInput(inputEl){
        this.$emit("setInput", inputEl);
      }
    }
  }
</script>